import {
  Card,
  Grid,
  TextField,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import AppService from "../../../../Configurations/Appservice";
import { useState, useEffect, useRef } from "react";
import { CUSTOMER_ORG_TYPE, CUSTOMER_USER_TYPE } from "../../../../Configurations/AppConfig";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import uuid from "react-uuid";
import { useLocation, useNavigate } from "react-router-dom";

const initialValues = {
  name: "",
  phone: "",
  email: "",
  admin: false,
};

const validationSchema = object({
  name: string().required("Name is Mandatory"),
  phone: string().required("Phone Number is Mandatory"),
  email: string().email().required("Email is Mandatory"),
});

const EditPartnerUser = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const formikRef = useRef();
  const naviagte = useNavigate();

  useEffect(() => {
    dispatch(updateScreenTitle("Edit Customer Organisation User"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    dispatch(showLoader());
    const userId = location.state?.userId;
    let params = {
      userId,
    };
    if (!userId) {
      dispatch(dismissLoader());
      return;
    }

    AppService.get("v1/user/details", { params })
      .then((response) => {
        formikRef.current.setFieldValue("name", response.name);
        formikRef.current.setFieldValue("phone", response.phoneNumber);
        formikRef.current.setFieldValue("email", response.emailId);
        formikRef.current.setFieldValue("admin", response.admin);
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  const _submitHandler = (values, { resetForm }) => {
    dispatch(showLoader());
    values.id = location.state?.userId;
    AppService.put("v1/user", values)
      .then((response) => {
        resetForm();
        dispatch(showSuccessMessage("User updated Successfully"));
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
        naviagte(-1);
      });
  };

  return (
    <WDBox py={1}>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_submitHandler}
          validationSchema={validationSchema}
          innerRef={formikRef}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>Edit User</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="name"
                        label="Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.name) && Boolean(touched.name)}
                        helperText={Boolean(touched.name) && errors.name}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="phone"
                        label="Phone Number"
                        fullWidth
                        type="tel"
                        as={TextField}
                        error={Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber)}
                        helperText={Boolean(touched.phoneNumber) && errors.phoneNumber}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox display="flex" height="100%" alignItems="center">
                      <Typography fontSize={14}>isAdmin &nbsp;</Typography>
                      <Field
                        type="checkbox"
                        name="admin"
                        as={FormControlLabel}
                        control={<Checkbox />}
                      />
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default EditPartnerUser;
